import { Injectable, OnDestroy } from '@angular/core';

import { SnFormFieldConfig } from '@lib/form';
import { SnDrawerService, SnDrawerRef, SnDrawerConfig } from '@lib/ui/drawer';

import { FilterComponent } from '../components/filter';

@Injectable({
  providedIn: 'root',
})
export class SnFilterService implements OnDestroy {
  constructor(private readonly _drawerService: SnDrawerService) {}

  public ngOnDestroy(): void {
    if (this._drawerService.drawers.has('filter')) {
      this._drawerService.close('filter');
    }
  }

  public createFilter<R>(
    config: SnDrawerConfig<SnFormFieldConfig[]>,
  ): SnDrawerRef<FilterComponent, SnFormFieldConfig[], R> {
    const baseConfig: SnDrawerConfig<SnFormFieldConfig[]> = {
      id: 'filter',
      width: 320,
      hasBackdrop: true,
    };

    return this._drawerService.open(FilterComponent, {
      ...baseConfig,
      ...config,
    });
  }
}
